import { render } from "./VerifyCodeView.vue?vue&type=template&id=06a0678e"
import script from "./VerifyCodeView.vue?vue&type=script&lang=js"
export * from "./VerifyCodeView.vue?vue&type=script&lang=js"

import "./VerifyCodeView.vue?vue&type=style&index=0&id=06a0678e&lang=css"

import exportComponent from "/Users/peterdevos/Apps/sendcloudholidaygiftsraffle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__